import { FC } from "react";
import { observer } from "mobx-react-lite";
import { ExpandedTable} from "../../../ui-kit";

import moduleStyles from "../SmsSettings.module.scss";
import { convertDate } from "../../../utils/helpers/data.helpers";
import { ExpandableKeys } from "../../../store/core";
import { Tag } from "antd";
import Constants from "../../../constants/Common";

const SentLogForm: FC = observer(({ record }) => {

  const keys = new ExpandableKeys();

  const columns = [
    {
      title: "Имя абонента",
      dataIndex: "abonentName",
      key: "abonentName",
      width: "5%",
      className: "align-left",
    },
    {
      title: "Способ отправки",
      dataIndex: "channelType",
      key: "channelType",
      width: "20%",
      className: "align-left", 
      render: (channelType) =>
      channelType == 1 ? "Смс" : "Email"
    },      
    {
      title: "Номер телефона",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
      width: "10%",
      className: "align-left",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: "10%",
      className: "align-left",
    },   
    {
      title: "Статуc",
      dataIndex: "deliveryStatus",
      key: "deliveryStatus",
      width: "20%",
      className: "align-left", 
      render: (deliveryStatus) =>
        deliveryStatus == 0 ? <Tag color='yellow'>Отправлено</Tag>
      : deliveryStatus == 1 ? <Tag color='green'>Доставлено</Tag>
      : deliveryStatus == 3 ? <Tag color='red'>Ошибка</Tag> : <></>      
    },  
    {
      title: "Дата доставки",
      dataIndex: "dtDelivered",
      key: "dtDelivered",
      width: "10%",
      className: "align-left",
      render: (dtDelivered) =>
      dtDelivered ? convertDate(dtDelivered, Constants.dateTimeFormat) : "",    
    },             
  ];

  return (
    <ExpandedTable
    columns={columns}
    data={record.sendEvents}
    rowKey={(rec) => rec.id}
    rowKeys={keys.keys}
    setRowKeys={keys.setKeys}    
  >
  </ExpandedTable>
  );
});

export default SentLogForm;
